import { render, staticRenderFns } from "./ClassSession.vue?vue&type=template&id=1cb5dbce&"
import script from "./ClassSession.vue?vue&type=script&lang=js&"
export * from "./ClassSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports